import tw from "twin.macro"
import styled from "@emotion/styled"

import { StyledContainer } from "../Styled/Container"
import { H1, RichText } from "../Styled/Text"

export const Page = tw.section`bg-white`
export const Container = tw(StyledContainer)`py-8 md:py-16`
export const Title = tw(H1)`mb-4 md:mb-8 text-navy`
export const Content = styled(RichText)`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${tw`text-navy`};
  }
  p {
    color: ${tw`text-grey-darker`};
  }
`
